__webpack_require__.p = "https://dex-tech-fe-production-c.squarecdn.com/main/_next/";